import axios from './ajax'

var http = {}

http.appProBaoming = async (info)=> {
  const data = await axios.post('/public/init/appProBaoming.do',info)
  return data.data
}
export {
  http
}



// WEBPACK FOOTER //
// ./src/fetch/api.js